import React, { useCallback, useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import Button from 'design-system/Button';
import SuccessView from 'design-system/SuccessView';
import EmptyComponent from 'design-system/EmptyComponent';
import { useDisableAndroidBackButton } from 'hooks';
import useColors from 'hooks/useColors';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import StatusBar from 'design-system/StatusBar';
import { AppView } from 'design-system';
import { isWeb } from '../../constants';
const strings = {
    screenTitle: 'Live export',
    done: 'Done',
    title: 'Google Sheets is now synced!',
    description: 'Your transactions will update automatically. You can disconnect anytime in settings.',
};
const ExportDataLiveSuccessScreen = ({ navigation }) => {
    const colors = useColors();
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTitle: '',
            gestureEnabled: false,
            headerLeft: EmptyComponent,
            title: strings.screenTitle,
            headerTintColor: colors.elements.primary,
        });
    }, [colors.elements.primary]);
    const finish = useCallback(() => {
        navigation.popTo('ExportDataLive');
    }, []);
    useDisableAndroidBackButton(() => {
        finish();
        return true;
    });
    return (<AppView withFrame={false} style={styles.container}>
        <StatusBar barStyle="dark-content" animated/>
        <SuccessView title={strings.title} subTitle={strings.description}>
          <View style={paddingHorizontalStyle}>
            <Button brand title={strings.done} onPress={finish}/>
          </View>
        </SuccessView>
      </AppView>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
export default ExportDataLiveSuccessScreen;
